// i18next-extract-mark-ns-start CoutureServices
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import broderies from '../assets/ourServices/couturier/broderies.svg';
import retouches from '../assets/ourServices/couturier/retouches.svg';
import creation from '../assets/ourServices/couturier/creation.svg';
import reparation from '../assets/ourServices/couturier/reparation.svg';
import upcycling from '../assets/ourServices/couturier/upcycling.svg';
import {
  tabletThresholdPixels, frames, mobileThresholdPixels, margins,
} from './home/v4/styledComponents';

const Container = styled.div<{marginTop: boolean}>`
  margin: ${margins.m15} ${frames.desktop} 0;
  max-width: 1180px;
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: space-between;
  gap: 16px;
  @media (max-width: ${tabletThresholdPixels}) {
    margin: ${(props) => props.marginTop ? `${margins.m14}` : 0} ${frames.tablet} 0;
    width: calc(100vw - (${frames.tablet}*2));
  }
  @media (max-width: ${mobileThresholdPixels}) {
    margin: ${(props) => props.marginTop ? `${margins.m8}` : 0} ${frames.mobile} ${margins.m11};
    width: calc(100vw - (${frames.mobile}*2));
    flex-direction: column;
    gap: 24px;
  }
`;

const Title = styled.h2`
  font-size: 28px;
  font-weight: 700;
  margin: 12px 0 0;
  @media (max-width: ${tabletThresholdPixels}) {
    font-size: 24px;
    margin: 8px 0 0;
  }
`;

const Text = styled.p`
  font-size: 16px;
  line-height: 24px;
  margin: 8px 0 0;
`;

const Img = styled.img`
  height: 64px;
  @media (max-width: ${mobileThresholdPixels}) {
    height: 50px;
  }
`;

type CouturiersData = {
  icon: string;
  title: string;
  text: string;
};

interface WorksBannerProps {
  works: CouturiersData[];
  marginTop: boolean;
}

function WorksBanner({ works = [], marginTop }: WorksBannerProps) {
  const { t } = useTranslation();

  const getCouturierDatas = (): CouturiersData[] => [
    {
      icon: retouches,
      title: t('Retouches'),
      text: t('Vêtement, rideau & accessoires'),
    },
    {
      icon: reparation,
      title: t('Réparation'),
      text: t('Vêtement, rideau & accessoires'),
    },
    {
      icon: creation,
      title: t('Création'),
      text: t('Rideau & accessoires'),
    },
    {
      icon: broderies,
      title: t('Broderie'),
      text: t('Vêtement, rideau & accessoires'),
    },
    {
      icon: upcycling,
      title: t('Upcycling'),
      text: t('Vêtement, rideau & accessoires'),
    },
  ];

  const datas = Object.keys(works).length > 0 ? works : getCouturierDatas() as CouturiersData[];
  return (
    <Container marginTop={marginTop}>
      {datas.map((work) => (
        <div key={work.title}>
          <Img src={work.icon} alt={work.title} />
          <Title>{work.title}</Title>
          <Text>{work.text}</Text>
        </div>
      ))}
    </Container>
  );
}

export default WorksBanner;
